/**
 * Popflex header-scroll.js — v2.3 (pairs with sections/header.liquid v2.3)
 *
 * Home page (data-header-scroll="transparent"):
 *   The theme's own <page-header> script decides when the header is transparent:
 *   it removes `pageheader--transparent` once the sticky header scrolls and adds it
 *   back at the top. This script only mirrors that state onto:
 *     - `pageheader--scrolled` on #pageheader
 *     - `section-header--scrolled` on the header section (fades IN the Yotpo banner)
 *
 * Other pages (data-header-scroll="sticky"):
 *   The Yotpo banner (#yp-locate) is moved just below the header section so it is no
 *   longer part of the sticky block, and `header-is-scrolled` on <html> fades it OUT
 *   once the page scrolls. Only the header bar stays stuck to the top.
 */
(() => {
  const TRANSPARENT = 'pageheader--transparent';
  const SCROLLED = 'pageheader--scrolled';
  const SECTION_SCROLLED = 'section-header--scrolled';
  const HTML_SCROLLED = 'header-is-scrolled';

  let observer = null;
  let onScroll = null;

  function setScrolled(header, scrolled) {
    header.classList.toggle(SCROLLED, scrolled);
    const section = header.closest('.section-header');
    if (section) section.classList.toggle(SECTION_SCROLLED, scrolled);
    document.documentElement.classList.toggle(HTML_SCROLLED, scrolled);
  }

  function initTransparent(header) {
    const sync = () => setScrolled(header, !header.classList.contains(TRANSPARENT));
    sync();
    observer = new MutationObserver(sync);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  function initSticky(header) {
    const section = header.closest('.section-header');
    const banner = document.getElementById('yp-locate');
    if (section && banner && section.contains(banner)) {
      // Theme editor re-render: drop the banner moved out on the previous load.
      const previous = section.nextElementSibling;
      if (previous && previous.id === 'yp-locate') previous.remove();
      section.after(banner);
      // The theme measures the header section for --theme-header-height; re-measure now the banner is out.
      const pageHeader = header.closest('page-header');
      if (pageHeader && typeof pageHeader.setHeaderHeightProperty === 'function') {
        pageHeader.setHeaderHeightProperty();
      }
    }

    // Same trigger point the theme uses on the home page: past the announcement bar, or any scroll at all.
    let ticking = false;
    const update = () => {
      ticking = false;
      const bar = document.querySelector('.section-announcement-bar');
      const threshold = bar ? bar.offsetTop + bar.clientHeight : 0;
      setScrolled(header, window.scrollY > threshold);
    };
    onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function init() {
    if (observer) observer.disconnect();
    if (onScroll) window.removeEventListener('scroll', onScroll);
    observer = null;
    onScroll = null;

    const header = document.querySelector('[data-header-scroll]');
    if (!header) return;

    const mode = header.dataset.headerScroll;
    if (mode === 'transparent') initTransparent(header);
    else if (mode === 'sticky') initSticky(header);
  }

  document.addEventListener('shopify:section:load', init);
  init();
})();
